var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hvh-flex column space-between"},[_c('h2',{staticClass:"hvh-h5 mb-4"},[_vm._v("Insurance Distribution")]),_c('HvhChart',{attrs:{"options":_vm.barChartInsuranceOptions,"visualization":_vm.barChartInsuranceData,"height":"350px"},on:{"item-clicked":_vm.emitValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }